import { useContext } from 'react';

import {
  SettingsContext,
  SettingsContextValue,
} from '../context/SettingsContext';

export const useSettings = (enforced = true): SettingsContextValue => {
  const context = useContext(SettingsContext);
  if (enforced && !context) {
    throw new Error('useSettings must be used inside a SettingsProvider!');
  }
  return context;
};
